import { ApolloClient, ApolloQueryResult, NormalizedCacheObject } from '@apollo/client';
import { handleQuery } from '@99designs/graph-utils';
import { WebOnboarderProductsDocument } from '../graphql/Recommendation.generated';
import type { WebOnboarderProductsQuery } from '../graphql/Recommendation.generated';

export async function getRecommendedProducts(
    client: ApolloClient<NormalizedCacheObject>,
    names: string[]
): Promise<WebOnboarderProductsQuery> {
    const { data, error } = await fetchRecommendedProducts(client, names);

    if (error) {
        throw error;
    }

    return data;
}

function fetchRecommendedProducts(
    client: ApolloClient<NormalizedCacheObject>,
    names: string[]
): Promise<ApolloQueryResult<WebOnboarderProductsQuery>> {
    return handleQuery<WebOnboarderProductsQuery>(client, {
        query: WebOnboarderProductsDocument,
        variables: {
            input: {
                names,
            },
        },
    });
}
